import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { reducer } from './reducer';
import { EffectsModule } from '@ngrx/effects';
import { TowAttemptStoreEffects } from './effects';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        StoreModule.forFeature('towAttempt', reducer),
        EffectsModule.forFeature([TowAttemptStoreEffects])
    ],
    providers: []
})
export class TowAttemptStoreModule {}
